import { API_BASE_URL } from '@ai-platform/ai-utils';

/**
 * Базовый класс для API запросов с автоматическим добавлением BASE_URL
 */
class ApiClient {
    private baseUrl: string;

    constructor() {
        this.baseUrl = API_BASE_URL;
    }

    private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
        const url = `${this.baseUrl}${endpoint}`;

        const response = await fetch(url, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });

        if (!response.ok) {
            throw new Error(`API Error: ${response.status} ${response.statusText}`);
        }

        return response.json();
    }

    async get<T>(endpoint: string): Promise<T> {
        return this.request<T>(endpoint, { method: 'GET' });
    }

    async post<T>(endpoint: string, data?: unknown): Promise<T> {
        return this.request<T>(endpoint, {
            method: 'POST',
            body: data ? JSON.stringify(data) : undefined,
        });
    }
}

export const apiClient = new ApiClient();

/**
 * Утилита для построения API URL
 * @param endpoint - путь к API endpoint (должен начинаться с /)
 * @returns полный URL с BASE_URL
 */
export const getApiUrl = (endpoint: string): string => {
    if (!endpoint.startsWith('/')) {
        throw new Error(`API endpoint should start with '/': ${endpoint}`);
    }

    return `${API_BASE_URL}${endpoint}`;
};
